import Navigation from "./Item/Navigation";
import Progress from "./Item/Progress";
import Title from "./Item/Title";
import Router from "./Router";

export default { Router, Item: { Navigation, Progress, Title } };
